/**
 * 문서관리 목록의 페이지 번호를 URL 쿼리(`?page=`)로 보존하기 위한 순수 헬퍼.
 *
 * 페이지가 컴포넌트 로컬 state면 목록 → 상세 → 뒤로가기에서 언마운트와 함께 사라져
 * 항상 1페이지로 리셋된다. URL에 올려두면 히스토리 복귀만으로 원래 페이지가 살아난다.
 */

/** URL 쿼리 키. */
export const PAGE_PARAM = 'page';

/**
 * `?page=` 값을 1 이상의 정수로 읽는다.
 * 없음·비정수·0 이하·NaN은 모두 1페이지로 본다(손으로 URL을 고쳐도 목록이 깨지지 않게).
 */
export function readPageParam(params: URLSearchParams): number {
  const raw = params.get(PAGE_PARAM);
  if (raw === null) return 1;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) return 1;
  const page = Math.floor(parsed);
  return page >= 1 ? page : 1;
}

/**
 * 페이지를 반영한 새 URLSearchParams를 만든다(원본 불변).
 * 1페이지는 키를 **지운다** — 기본값을 URL에 남기지 않아야 `/reports`와 `/reports?page=1`이
 * 갈라지지 않고, 필터 변경 시의 "1페이지로 리셋"이 URL에서도 깨끗하게 보인다.
 * 그 외 쿼리(`tab` 등)는 그대로 보존한다.
 */
export function writePageParam(params: URLSearchParams, page: number): URLSearchParams {
  const next = new URLSearchParams(params);
  if (page <= 1) next.delete(PAGE_PARAM);
  else next.set(PAGE_PARAM, String(Math.floor(page)));
  return next;
}
